<template>
    <div id="chart" class="dimension">
  
      <!-- PC : RADAR -->
      <apexchart
        v-if="!isMobile"
        key="radar"
        type="radar"
        height="100%"
        width="100%"
        :options="radarOptions"
        :series="series"
      ></apexchart>
  
      <!-- MOBILE : BARRES -->
      <apexchart
        v-else
        key="bar"
        type="bar"
        height="500"
        width="100%"
        :options="barOptions"
        :series="series"
      ></apexchart>
  
    </div>
  </template>
  <script>
  import VueApexCharts from "vue3-apexcharts";
  
  export default {
    components: {
      apexchart: VueApexCharts,
    },
  
    props: {
      dimensions: {
        type: Array,
        default: () => []
      }
    },
  
    data() {
      return {
        isMobile: window.innerWidth <= 768,
  
        allDimensions: [
          "Racisme",
          "Négationnisme",
          "Déclin et renouveau",
          "Validisme",
          "Fragilité de genre",
          "Agressivité",
          "Soumission",
          "Complotisme",
          "Performance et libéralisme"
        ]
      };
    },
  
    computed: {
  
      /* =========================
         DIMENSIONS
      ========================= */
  
      displayedDimensions() {
        return this.allDimensions.map(name => {
  
          const found = this.dimensions.find(
            d => d.dimensionName === name
          );
  
          return found || {
            dimensionName: name,
            score: 0
          };
        });
      },
  
  
      /* =========================
         SERIES
      ========================= */
  
      series() {
        return [
          {
            name: "Score",
            data: this.displayedDimensions.map(
              d => d.score
            )
          }
        ];
      },
  
  
      /* =========================
         OPTIONS RADAR
         → PC UNIQUEMENT
      ========================= */
  
      radarOptions() {
  
        return {
          chart: {
            type: "radar",
            background: "transparent",
            parentHeightOffset: 0
          },
  
          toolbar: {
            show: true,
  
            tools: {
              download: true
            }
          },
  
          dataLabels: {
            enabled: true
          },
  
          plotOptions: {
            radar: {
              size: "180",
  
              polygons: {
                strokeColors: "#444",
                connectorColors: "#444",
  
                fill: {
                  colors: [
                    "#1b1d20",
                    "#23262b"
                  ]
                }
              }
            }
          },
  
          title: {
            text: "Dimensions détectées",
  
            style: {
              color: "#ffffff",
              fontSize: "22px"
            }
          },
  
          colors: ["#dc2626"],
  
          markers: {
            size: 6,
  
            colors: ["#dc2626"],
  
            strokeColors: "#fff",
  
            strokeWidth: 2
          },
  
          fill: {
            colors: ["#dc2626"],
  
            opacity: 0.25
          },
  
          stroke: {
            width: 3,
  
            colors: ["#dc2626"]
          },
  
          tooltip: {
            y: {
              formatter: function (val) {
                return val;
              }
            }
          },
  
          xaxis: {
            categories:
              this.displayedDimensions.map(
                d => this.wrapLabel(d.dimensionName)
              ),
  
            labels: {
              style: {
                colors: "#ffffff",
                fontSize: "13px",
                fontWeight: 600
              }
            }
          },
  
          yaxis: {
            min: 0,
            max: 10,
            tickAmount: 10,
  
            labels: {
              style: {
                colors: "#b5b5b5",
                fontSize: "12px"
              }
            }
          },
  
          responsive: [
            {
              breakpoint: 1200,
  
              options: {
                plotOptions: {
                  radar: {
                    size: 180
                  }
                },
  
                xaxis: {
                  labels: {
                    style: {
                      fontSize: "11px"
                    }
                  }
                }
              }
            }
          ]
        };
      },
  
  
      /* =========================
         OPTIONS BARRES
         → MOBILE UNIQUEMENT
      ========================= */
  
      barOptions() {
  
        return {
          chart: {
            type: "bar",
            background: "transparent",
            parentHeightOffset: 0,
            toolbar: {
              show: false
            }
          },
  
          plotOptions: {
            bar: {
              horizontal: true,
              borderRadius: 5,
              barHeight: "55%"
            }
          },

          colors: ["#dc2626"],
  
          dataLabels: {
            enabled: true,
  
            style: {
              colors: ["#ffffff"],
              fontSize: "11px",
              fontWeight: 600
            },
  
            offsetX: 5
          },
  
          xaxis: {
            categories:
              this.displayedDimensions.map(
                d => d.dimensionName
              ),
  
            min: 0,
            max: 10,
            tickAmount: 5,
  
            labels: {
              style: {
                colors: "#b5b5b5",
                fontSize: "10px"
              }
            }
          },
  
          yaxis: {
            labels: {
                align: "left",

                style: {
                colors: "#ffffff",
                fontSize: "11px",
                fontWeight: 600
                },

                maxWidth: 150,

                offsetX: -5
            }
        },
          grid: {
            padding: {
                left: 0,
                right: 10
            },
            borderColor: "#33363b",
            strokeDashArray: 3
          },
  
          fill: {
            opacity: 0.9
          },
  
          tooltip: {
            theme: "dark",
  
            y: {
              formatter: function (val) {
                return val;
              }
            }
          }
        };
      }
    },
  
  
    /* =========================
       RESIZE
    ========================= */
  
    mounted() {
      window.addEventListener(
        "resize",
        this.checkMobile
      );
    },
  
  
    beforeUnmount() {
      window.removeEventListener(
        "resize",
        this.checkMobile
      );
    },
  
  
    methods: {
  
      checkMobile() {
        this.isMobile =
          window.innerWidth <= 768;
      },
  
  
      wrapLabel(label, maxLength = 16) {
  
        const words = label.split(" ");
  
        const lines = [];
  
        let currentLine = "";
  
        for (const word of words) {
  
          if (
            (currentLine + " " + word)
              .trim()
              .length <= maxLength
          ) {
  
            currentLine =
              (currentLine + " " + word)
                .trim();
  
          } else {
  
            lines.push(currentLine);
  
            currentLine = word;
          }
        }
  
        if (currentLine) {
          lines.push(currentLine);
        }
  
        return lines.length > 1
          ? lines
          : label;
      }
    }
  };
  </script>
  
  <style scoped>
  
  /* =========================
     GRAPHIQUE
  ========================= */
  
  .dimension {
    width: 100%;
    height: 100%;
    min-height: 500px;
  }
  
  
  /* =========================
     APEXCHARTS
  ========================= */
  
  :deep(.apexcharts-menu) {
    background: #1b1d20;
  
    border: 1px solid #30343a;
  
    border-radius: 10px;
  }
  
  :deep(.apexcharts-menu-item) {
    color: #e5e7eb;
  }
  
  :deep(.apexcharts-menu-item:hover) {
    background: #991b1b;
  
    color: white;
  }
  
  :deep(.apexcharts-toolbar svg) {
    fill: #dc2626;
  }
  
  :deep(.apexcharts-toolbar svg:hover) {
    fill: #ef4444;
  }
  
  
  /* =========================
     TABLETTE
  ========================= */
  
  @media (max-width: 1200px) {
  
    .workspace {
      grid-template-columns: 1fr;
    }
  
    .result-panel {
      min-height: 400px;
    }
  }
  
  
  /* =========================
     MOBILE
  ========================= */
  
  @media (max-width: 768px) {
  
    .dimension {
      height: 500px;
  
      min-height: 0;
  
      width: 100%;
    }
  }
  
  </style>